import HubAccessTherapyModule from './HubAccessTherapyModule'

export default HubAccessTherapyModule
